import type { UIFeatures } from '@models/Account'

/**
 * The ui_features visibility rule, shared by every surface that composes
 * it with a perm check (web/Teams nav, TeamDashboard, Dashboard Overview,
 * FinanceSettings header): a feature hidden for the viewer's axis
 * (admin/user) never shows even when perms would allow it; an enabled or
 * UNSET feature falls through to the perm check (absent key = visible,
 * the Features screen's default). Cosmetic only — endpoint access stays
 * RBAC-governed.
 */
export const isUIFeatureVisible = (key: keyof UIFeatures, isAdmin: boolean, uiFeatures?: UIFeatures): boolean => {
  const setting = uiFeatures?.[key]
  if (!setting) return true
  return isAdmin ? setting.admin : setting.user
}
